const Glossuk = () => {

    return ( 
      
      <div id="glossuk">
        <p>  </p>
        <h1 className="glosstitle">Glossary</h1>
        <p>  </p>
        <div className="glosscontent">
            <p> 
                <span style={{fontWeight: 'bold'}} > Trip. </span> 
                <span style={{color: 'green'}}> Course started by a validation. </span>
            </p>
            <p> 
                <span style={{fontWeight: 'bold'}} > Journey. </span> 
                <span style={{color: 'green'}}> ​Sequence of trips started by validations all, but the first one, of which are separated from the next one by less than 70 minutes. </span>
            </p>
            <p> 
            <span style={{fontWeight: 'bold'}} > Stretch. </span> 
            <span style={{color: 'green'}}> Part of the network between two consecutive stations. </span>
            </p>
            <p> 
            <span style={{fontWeight: 'bold'}} > ​Passenger-Stretch (Pax Stretch). </span> 
            <span style={{color: 'green'}}> Measurement unit for demand: when a passenger travels by metro between two consecutive stations, demand increases by one Passenger-stretch. When ten passengers travel in a metro vehicle between two consecutive stations, demand increases by ten Passenger-stretches. </span>
            </p>
            <p> 
            <span style={{fontWeight: 'bold'}} > Passenger-Km (Pax Km). </span> 
            <span style={{color: 'green'}}> Measurement unit for demand: when a passenger travels by metro between two consecutive stations one km apart, demand increases by one Passenger-km. When ten passengers travel in a metro vehcle bewteen two consecutive stations 500 metres apart, demand increases by five Passenger-kms. </span>
            </p>
            <p> 
            <span style={{fontWeight: 'bold'}} > Vehicle-Km (VKm). </span> 
            <span style={{color: 'green'}}> Measurement unit for production / supply: when a vehicle in commercial operation travels between two stations one km apart, supply increases by one Vehicle-km. </span>
            </p>
            <p> 
            <span style={{fontWeight: 'bold'}} > Seat-km (SKm). </span> 
            <span style={{color: 'green'}}> Measurement unit for production / supply: when a Eurotram vehicle, whose capacity is for 216 passengers, travels in commercial operation between two consecutive stations one km apart, supply increases by 216 seat-kms. If the vehicle is a Tram-Train, demand increases by 248 seat-kms. When a composition of two Eurotrams in commercial operation travels bewteen two stations one km apart, supply increases by 432 seat-kms. </span>
            </p> 
            <p> 
            <span style={{fontWeight: 'bold'}} > Load factor (LF). </span> 
            <span style={{color: 'green'}}> Ratio between passenger-kms and seat-kms in respect of the same space and time. Average percentage of seats taken in that space and time period </span>
            </p> 
        </div>
      </div>
    );
}

export default Glossuk;